class AnimationSubsSubHero {

	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleSubsSubHero = this.sectionsContainer.querySelectorAll('.subs-sub-hero');
		
		if (!this.$moduleSubsSubHero.length)
			return;
		
		this.$moduleSubsSubHeroElements = [];
		this.$moduleSubsSubHero.forEach(module => {
			this.$moduleSubsSubHeroElements.push(module.querySelectorAll('.anima'));
		});

		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$moduleSubsSubHero.forEach((module, index) => {
		    console.log(this.$moduleSubsSubHeroElements[index])
			gsap.set(module, { opacity: 1 });
			gsap.set(this.$moduleSubsSubHeroElements[index], { yPercent: 20, opacity: 0, onComplete: () => {
				this.initAnimate(index);
			} });
		});
	}

	initAnimate(index) {
		const moduleSubsSubHero = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleSubsSubHero[index],
				start: '-20% 50%'
			},
			onComplete: () => {
				gsap.set(this.$moduleSubsSubHeroElements[index], { clearProps: true });
			}
        });

        moduleSubsSubHero.addLabel('step1');
        moduleSubsSubHero.to(this.$moduleSubsSubHero[index], { opacity: 1, duration: 1 }, 'step1');
		moduleSubsSubHero.to(this.$moduleSubsSubHeroElements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}
export default AnimationSubsSubHero;
